// @flow

import type { State } from "@store/reducers";
import type { PropertiesSchema, PaginationExtendedType } from "@types";
import type {
  ReportingParametersData,
  ReportingParametersState,
  ReasonToBeExcluded,
} from "@modules/service/reducer/reporting-parameters/types";
import { getPagination } from "@selectors";

export type ReportingParametersSelector = (state: State) => ReportingParametersState;
export type GetReportingParametersSchema = (state: State) => ?PropertiesSchema;
export type GetReportingParameters = (state: State) => ReportingParametersData;
export type GetReasonsToBeExcluded = (state: State) => Array<ReasonToBeExcluded>;
export type GetReasonsToBeExcludedSchema = (state: State) => ?PropertiesSchema;
export type GetEditReasonToBeExcluded = (state: State) => ?ReasonToBeExcluded;
export type SelectReasonsToBeExcludedPage = (state: State) => number | null;
export type ReportingParametersModalOpen = (state: State) => boolean;
export type ReasonsToBeExcludedModalOpen = (state: State) => boolean;
export type DeleteReasonToBeExcludedConfirmModalOpen = (state: State) => boolean;

export const reportingParametersSelector: ReportingParametersSelector = state =>
  state.service.reportingParameters;

export const getReportingParameters: GetReportingParameters = state => {
  return state.service.reportingParameters.data;
};

export const getReportingParametersSchema: GetReportingParametersSchema = state =>
  reportingParametersSelector(state).schema;

export const getReasonsToBeExcluded: GetReasonsToBeExcluded = state =>
  reportingParametersSelector(state).reasonsToBeExcluded.content || [];

export const getEditReasonToBeExcluded: GetEditReasonToBeExcluded = state =>
  reportingParametersSelector(state).editReasonToBeExcluded;

export const getReasonsToBeExcludedSchema: GetReasonsToBeExcludedSchema = state =>
  reportingParametersSelector(state).reasonsToBeExcludedSchema;

export const selectReasonsToBeExcludedPagination = (state: State): PaginationExtendedType =>
  getPagination(reportingParametersSelector(state).reasonsToBeExcluded);

export const selectReasonsToBeExcludedPage: SelectReasonsToBeExcludedPage = state =>
  selectReasonsToBeExcludedPagination(state).pageNumber;

export const reasonsToBeExcludedModalOpen: ReasonsToBeExcludedModalOpen = state =>
  reportingParametersSelector(state).modals.reasonsToBeExcluded.visible;

export const reportingParametersModalOpen: ReportingParametersModalOpen = state =>
  reportingParametersSelector(state).modals.reportingParameters.visible;

export const deleteReasonToBeExcludedConfirmModalOpen: ReportingParametersModalOpen = state =>
  reportingParametersSelector(state).modals.deleteReasonToBeExcludedConfirm.visible;

export const scheduledReportsModalOpen = (state: State) => {
  return state.service.reportingParameters.modals.scheduledReports.visible;
};

export const scheduledReportsWarningModalOpen = (state: State) => {
  return state.service.reportingParameters.modals.scheduledReportsWarning.visible;
};
